@if (isLoading) {
  <loader [config]="loaderConfig"></loader>
}

<div class="card risk-view-card">
  <div class="card-header d-flex align-items-center gap-2">
    <h3 class="card-title mb-0">Risk</h3>
    @if (code) {
      <span class="badge risk-code-badge">{{ code }}</span>
    }
  </div>

  <div class="card-body">
    <risk-form
      [risk]="risk"
      [riskId]="riskId"
      [isEditPage]="true"
      [readonlyForm]="true">
    </risk-form>
  </div>

  @if (canModify) {
    <div class="card-footer">
      <div class="d-flex justify-content-center align-items-center gap-2 my-2">
        <button type="button" class="btn btn-primary" (click)="goToEdit()">Edit risk</button>
      </div>
    </div>
  }
</div>
